import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from './_services/lang-update.service';

@Pipe({
    name: 'equipmentTypes',
    standalone: false
})
export class EquipmentTypesPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private langService: LangUpdateService){
      this.langService.prepare(this, this.translate);
    }

  transform(value: string, ...args: unknown[]): unknown {
    if(value){
    console.log(value.split(','));
    console.log(value);
    let result = "";
    value.split(',').forEach(element => {
      if (result === ''){
        
      result += this.translate.instant('objects.' + element);
      }else{
      result += "," + this.translate.instant('objects.' + element);
      }
    });
    console.log(result);
    return result;
  }else{
    return '';
  }
  }

}
